import { render } from "./UpperHeader.vue?vue&type=template&id=56e3b65d"
import script from "./UpperHeader.vue?vue&type=script&lang=js"
export * from "./UpperHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__